import React, { useMemo } from 'react';

import { useNavigate } from 'react-router-dom';

import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button.tsx';
import { type ErrorResponse } from '@/hooks/common/useError';

interface Props {
  error: ErrorResponse;
}
const AccountRegistrationVerifyError: React.FC<Props> = ({ error }) => {
  const navigate = useNavigate();
  const title = useMemo(() => {
    switch (error.status) {
      case 400:
      case 422:
        return '認証URLが不正です';
      case 403:
        return 'URLの有効期限が切れています';
      default:
        return '認証URLが不正です';
    }
  }, [error.status]);

  return (
    <JumbotronPanel panelHeaderTitle="アカウントの仮登録">
      <JumbotronTitle>{title}</JumbotronTitle>
      <JumbotronDescription>
        認証ができませんでした。
        <br />
        再度設定の手続きを行ってください。
      </JumbotronDescription>
      <JumbotronButtonArea>
        <Button
          onClick={() => navigate('/registration')}
          size="m"
          color="primary"
        >
          アカウントの設定へ
        </Button>
      </JumbotronButtonArea>
    </JumbotronPanel>
  );
};

export default AccountRegistrationVerifyError;
